export default {
  "content": "<path d=\"M4 17.5a2 2 0 110 4 2 2 0 010-4zM20 17.5a2 2 0 110 4 2 2 0 010-4zM13 10h7a1 1 0 011 1v5h-2v-4H5v4H3v-5a1 1 0 011-1h7V7h2v3zM12 1.5a2 2 0 110 4 2 2 0 010-4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};